import {useState} from "react";
import {Col, Row} from "react-bootstrap";
import {RRTruckType} from "../../types/RRTruckType";
import RRTable from "../../components/rr-table/RRTable";
import EditDeleteConfirm from "../../components/EditDeleteConfirm";
import CenteredColumn from "../../components/CenteredColumn";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons";

export interface Props {
    trucks: RRTruckType[],
    onSelect?: (result: any) => any,
    onEdit: (truck: RRTruckType) => any,
}


export function TrucksList({trucks, onSelect, onEdit}: Props) {
    const [deleteTruck, setDeleteTruck] = useState<RRTruckType | null>(null);

    return (
        <>
            {
                trucks.length === 0 &&
                <Row className={"m-5"}>
                    <Col className={"text-center fw-bold"}>Няма дефинирани превозни средства</Col>
                </Row>
            }


            {
                trucks.length > 0 &&
                <>
                    <div className={"max-h-50vh scrollable"}>
                        <RRTable>
                            <thead>
                            <tr>
                                <th className={"w-75px text-nowrap text-center"}></th>
                                <th>Име</th>
                                <th>Рег. номер</th>
                                <th className={"text-end"}>Ср.разход</th>
                                <th className={"text-end"}>Километраж</th>
                                <CenteredColumn header>Собствен?</CenteredColumn>
                                <CenteredColumn header>Активен?</CenteredColumn>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                trucks.map((item: RRTruckType) => (
                                    <tr key={item.id} onClick={() => onSelect && onSelect(item)}>
                                        <EditDeleteConfirm
                                            confirm={deleteTruck?.id === item.id}
                                            onEdit={() => {
                                                onEdit(item);
                                            }}
                                            onDelete={() => {
                                                setDeleteTruck(item);
                                            }}
                                            onConfirm={() => {
                                                if (deleteTruck) {
                                                    setDeleteTruck(null);
                                                }
                                            }}
                                            onReject={() => {
                                                setDeleteTruck(null);
                                            }}
                                        />
                                        <td>{item.name}</td>
                                        <td>{item.plate}</td>
                                        <td className={"text-end"}>{item.consumption}</td>
                                        <td className={"text-end"}>{item.lastKm}</td>
                                        <CenteredColumn>
                                            {
                                                item.isOwn ? <FontAwesomeIcon icon={faCheck} color={"green"}/> : null
                                            }
                                        </CenteredColumn>
                                        <CenteredColumn>
                                            {
                                                item.isActive ? <FontAwesomeIcon icon={faCheck} color={"green"}/> : null
                                            }
                                        </CenteredColumn>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </RRTable>
                    </div>
                </>
            }
        </>
    )
}
